<template>
  <div>
      <header class="header" :class="{'settings': $route.name === 'AppSetting'}">
      <div class="container-fluid">
         <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12">
               <a href="/projects">
                 <img class="img-responsive pr-2 mb-1" src="@/assets/images/iconlogo.png" alt="logo">
               </a>

            <div class="dropdown projects-dropdown d-inline show">
              <a @click.prevent="activeSearchInput" class="btn ml-3  border-left border-right " href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                 {{$t("change_project")}}
              </a>
              <div class="dropdown-menu projects-list-dropdown shadow" aria-labelledby="dropdownMenuLink">
                <template>
                  <form class="inpit mt-2 mb-1 px-2 w-100">
                    <input type="text" id="projectSearchInput" v-model="search_qry" class="form-control" :placeholder="$t('search')" autofocus>
                    <i class="fa fa-search position-absolute text-secondary" aria-readonly="true" style="top: 18px; right: 17px"></i>
                  </form>
                  <a v-for="(pro, index) in projectdropdown" :href="`/project/${pro.projectid}/photos`" :key="pro.projectid" v-if="pro.status == true">
                    <div class="dropdown-item border-top pt-2 pb-2" style="min-height:60px">
                      <div class="float-left">
                        <div data-aspect-ratio="4:3" class="mb-2 mt-2" style="width: 50px;margin-right:1rem;">
                          <div :style="{ 'backgroundImage': 'url(' + getImgUrl(pro) + ')' }" ref="img"></div>
                        </div>
                      </div>
                      <span class="d-flex mt-3" style="margin-left:60px;">{{pro.name}}</span>
                    </div>
                  </a>
                </template>
              </div>
            </div>

            <div class="title-of-header d-sm-block">
            {{projectName}}
            </div>
            <div class="dropdown float-right mt-1">
              <span class="font-10" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{nameShowInheader }}
              </span>

              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" data-toggle="modal" data-target="#exampleModalCenter" href="#" @click="emptyModal">
                  <img class="img-responsive" src="@/assets/images/Shape.png" alt="user" >{{$t('profile_edit')}}
                </a>
                <a class="dropdown-item" data-toggle="modal" data-target="#exampleModalCenter2" href="#">
                  <img class="img-responsive" src="@/assets/images/Shape1.png" alt="shapw">{{$t('language')}}
                </a>
<!--                <a class="dropdown-item" href="#"><img class="img-responsive" src="@/assets/images/Shape2.png" alt="shapw"> Kundenadministration</a>-->
                <a class="dropdown-item" href="#" @click="logout()">
                  <img class="img-responsive" src="@/assets/images/Shape3.png" alt="shapw">{{$t('logout')}}
                </a>
              </div>
            </div>
            <div class="profile-pic float-right">

              <span style="width: 40px; margin-right: 45px;">
                <a  href="#" target="_blank" style="color:#666666; position: absolute;" alt="Hilfe & Anleitungen" title="Hilfe & Anleitungen" id="navbarHelpDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa-regular fa-circle-question" style="font-size: 30px; margin-top: 2px;"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarHelpDropdown">
                  <a class="dropdown-item" target="_blank" href="https://projectdocu.com/hilfe-und-tutorials-baustellendokumentation/">
                    <img class="img-responsive" src="@/assets/images/Shape.png" alt="user" >Video Anleitungen
                  </a>
                </div>
              </span>

              <template v-if="usercan('admin')">
                <router-link :to="{ name: 'AppSetting', params: { id: $route.params.id }}" >
                  <img class="img-responsive pr-3 bg-white" src="@/assets/images/setting.png" style="cursor: pointer; padding-top: 2px" alt="user">
                </router-link>
              </template>

            </div>
          </div>
        </div>

        <div class="row navbar-dark" v-if="$route.name !== 'AppSetting'">
            <div class="col-xl-12 col-lg-12 col-md-12">
               <nav class="navbar navbar-expand-lg p-0">

                 <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                   <span class="navbar-toggler-icon"></span>
                 </button>
                 <div class="collapse navbar-collapse" id="navbarText">
                   <ul class="navbar-nav mx-auto">
                     <li class="nav-item" :class="{ active: $route.name === 'photo' }">
                     <router-link  class="nav-link" :to="{ name: 'photo', params: { id: this.$route.params.id }}">{{$t('photos')}}</router-link>
                     </li>
                     <li class="nav-item" :class="{ active: $route.name === 'Plan'  }">
                         <router-link  class="nav-link" :to="{ name: 'Plan', params: { id: this.$route.params.id }}">{{$t('plans')}}</router-link>
                     </li>
                     <li class="nav-item">
                       <a class="nav-link dropdown-toggle" :class="{active: $route.path.includes('/preport') || $route.path.includes('/construction-report') }" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                         Dokumentation
                       </a>
                       <div class="dropdown-menu">
                         <router-link  class="dropdown-item" :to="{ name: 'photoDocumentation', params: { id: this.$route.params.id }}">
                           {{$t("photo_documentation")}}
                         </router-link>

                         <router-link  class="dropdown-item" :to="{ name: 'constructionDocs', params: { id: this.$route.params.id }}">
                           <span> Bautagebuch </span>
                         </router-link>

                       </div>
                     </li>
                     <li class="nav-item">
                       <router-link  class="nav-link" :to="{ name: 'tasksList', params: { id: this.$route.params.id }}">
                         {{$t('flaw')}}
                       </router-link>
                     </li>
                     <li class="nav-item" :class="{ active: $route.name === 'Tickets'  }">
                       <router-link  class="nav-link" :to="{ name: 'Tickets', params: { id: this.$route.params.id }}">{{$t('tickets')}}</router-link>
                     </li>
                   </ul>

                 </div>
               </nav>
            </div>
        </div>
      </div>
      <!-- Login expired Modal-->
      <div
        class="modal fade"
        id="loginexpiredmodal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content col-4" style="margin: 0 auto;">
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div class="text-center">
                    <p>Ihr Login ist abgelaufen.<br /><br />Bitte melden sie sich neu an.</p>
                    <br />
                    <br />
                    <a href="/" class="btn btn-danger">zum Login</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal 1-->
      <div
        class="modal fade"
        id="exampleModalCenter"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div class="response-alert">
          <div class="alert alert-success alert-dismissible" v-for="m in modal3">
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            <strong></strong>
            {{m}}
          </div>
          <div class="alert alert-danger alert-dismissible" v-for="e in emodal3">
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            <strong></strong>
            {{e}}
          </div>
        </div>
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="spinner-cover" style="display: block;">
            <div class="spinner"></div>
          </div>
          <div class="modal-content col-6" style="margin: 0 auto;">
            <form @submit.prevent="updateProfile()" class="form-border-none" >
              <div class="modal-body">
                <div class="row row-data">
                  <div class="col-12 pro-style">{{ $t("profile_edit")}}</div>
                  <div class="col-lg-1 col-md-1 col-sm-1 col-1st">
                    <img class src="@/assets/images/user.png" alt="user" />
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-2nd">
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label class="form-label">{{ $t("email")}} {{ $t("address")}} ({{ $t("user_name")}}) *</label>
                        <div class="input-group">
                          <input
                            readonly
                            class="input--style-2"
                            type="text"
                            v-model="user.email"
                            @blur="$v.user.email.$touch()"
                            :class="{ 'is-invalid': submitted && $v.user.email.$error }"/>
                        </div>
                        <div v-if="submitted && !$v.user.email.email || (submitted && !$v.user.email.required)"
                             class="text-danger">{{ $t('email') }} {{ $t('is_required') }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label class="form-label">{{ $t("salutation")}} *</label>
                        <select
                          class="custom-select cus-select custom-select-sm mb-3 mt-1 select-box"
                          v-model="user.gender"
                          @blur="$v.user.gender.$touch()"
                          :class="{ 'is-invalid': submitted && $v.user.gender.$error }">
                          <option value="0">{{$t("mr")}}</option>
                          <option value="1">{{$t("mrs")}}</option>
                        </select>
                        <div
                          v-if="submitted && !$v.user.gender.required"
                          class="text-danger"
                        >{{ $t('salutation') }} {{ $t('is_required') }}</div>
                      </div>

                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label class="form-label">{{ $t("title")}}</label>
                        <div class="input-group">
                          <input class="input--style-2" type="text" v-model="user.title"/>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label class="form-label">{{ $t("first_name")}} *</label>
                        <div class="input-group">
                          <input class="input--style-2" type="text" name="name" v-model="user.firstname"
                            @blur="$v.user.firstname.$touch()"
                            :class="{ 'is-invalid': submitted && $v.user.firstname.$error }"
                          />
                        </div>
                        <div
                          v-if="submitted && !$v.user.firstname.required"
                          class="text-danger"
                        >{{ $t('first_name') }} {{ $t('is_required') }}</div>
                      </div>

                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label class="form-label">{{ $t("last_name")}} *</label>
                        <div class="input-group">
                          <input
                            class="input--style-2"
                            type="text"
                            name="name"
                            v-model="user.lastname"
                            @blur="$v.user.lastname.$touch()"
                            :class="{ 'is-invalid': submitted && $v.user.lastname.$error }"
                          />
                        </div>
                        <div
                          v-if="submitted && !$v.user.lastname.required"
                          class="text-danger"
                        >{{ $t('last_name') }} {{ $t('is_required') }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label class="form-label">{{ $t("company")}} *</label>
                        <div class="input-group">
                          <input
                            @blur="$v.user.company.$touch()"
                            :class="{ 'is-invalid': submitted && $v.user.company.$error }"
                            class="input--style-2"
                            type="text"
                            name="name"
                            v-model="user.company"
                          />
                        </div>
                        <div
                          v-if="submitted && !$v.user.company.required"
                          class="text-danger"
                        >{{ $t('company') }} {{ $t('is_required') }}</div>
                      </div>
                    </div>

                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 col-3rd" style="display:none;">
                  <span style="font-weight: 500">
                    <img class src="@/assets/images/Group.png" alt="user" />
                    &nbsp;&nbsp; {{ $t("passwordc") }}
                  </span>
                    <div class="group-txt">{{ $t("change_account_password") }}</div>
                    <div v-if="passwordChange">
                      <div class="sm-form">
                        <form @submit.prevent="updatePassword()" class="needs-validation" novalidate>
                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <label class="form-label1">{{ $t('current_password') }} *</label>
                              <div class="input-group inp">
                                <input
                                  class="input--style-2 form-control"
                                  type="password"
                                  name="name"
                                  v-model="currentpassword"
                                  @blur="$v.currentpassword.$touch()"
                                  :class="{ 'is-invalid':submitted1 && $v.currentpassword.$error }"
                                />
                                <!--<div v-if="!$v.currentpassword.required" class="invalid-feedback">
                                  {{ $t('current_password') }} {{ $t('is_required') }}
                                </div>-->
                                <div class="valid-feedback"></div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <label class="form-label1">{{ $t('new_password') }} *</label>
                              <div class="input-group inp">
                                <input
                                  class="input--style-2 form-control"
                                  type="password"
                                  name="name"
                                  v-model="password"
                                  @blur="$v.password.$touch()"
                                  :class="{ 'is-invalid':submitted1 && $v.password.$error }"
                                />
                                <!--<div v-if="!$v.currentpassword.required" class="invalid-feedback">
                                        {{ $t('current_password') }} {{ $t('is_required') }}
                                </div>-->
                                <div
                                  v-if="$v.password.required && !$v.password.minLen"
                                  class="invalid-feedback"
                                >{{ $t('password') }} {{ $t('must_be_at_least') }} {{$v.password.$params.minLen.min}} {{ $t('characters') }}</div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <label class="form-label1">{{ $t('confirm_password') }} *</label>
                              <div class="input-group inp">
                                <input
                                  class="input--style-2 form-control"
                                  type="password"
                                  name="name"
                                  v-model="repeatpassword"
                                  @blur="$v.password.$touch()"
                                  :class="{ 'is-invalid':submitted1 && $v.repeatpassword.$error }"
                                />

                                <div
                                  v-if="$v.repeatpassword.$error"
                                  class="invalid-feedback"
                                >{{ $t('password') }} {{ $t('not_matched') }}</div>
                              </div>
                            </div>
                          </div>

                          <div class="p-t-30">
                            <!-- <button class="btn btn-sf btn--radius btn--green" type="submit">save</button>
                          <button
                      type="button"
                      @click="passwordChange=!passwordChange"
                      class="btn btn-sf btn--radius btn--green"
                            >{{ $t("hide") }}</button>-->
                          </div>
                        </form>
                      </div>
                    </div>
                    <button
                      type="button"
                      v-if="!passwordChange"
                      @click="passwordChange='false'"
                      class="btn btn-light btn-sm btn-small">
                      {{ $t("change") }}</button>
                  </div>
                </div>
              </div>
              <div class="modal-footer mf-1st">
                <button
                  type="button"
                  class="btn mode-d"
                  data-dismiss="modal"
                >{{ $t("cancel")}}</button>
                <button type="submit" class="btn btn-primary mode-s">{{ $t("save")}}</button>
                <div class="cross-close" data-dismiss="modal">
                  <img src="@/assets/images/cross.png" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Modal 2-->
      <div
        class="modal fade"
        id="exampleModalCenter2"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content col-6" style="margin: 0 auto;">
            <form @submit.prevent="changeLang()">
              <div class="modal-body">
                <div class="row row-data">
                  <div class="col-12 pro-style2">{{$t("set_the_language")}}</div>

                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="custom-control custom-radio cus-radio">
                      <input
                        type="radio"
                        class="custom-control-input"
                        id="customRadio"
                        value="de"
                        v-model="lang"
                      />
                      <label class="custom-control-label" for="customRadio">
                        <span class="img-flag">
                          <img class="img-responsive" src="@/assets/images/germany.png" alt="user" />
                        </span>
                        <span class="language">Deutsch</span>
                      </label>
                    </div>

<!--                    <div class="custom-control custom-radio cus-radio">-->
<!--                      <input-->
<!--                        type="radio"-->
<!--                        class="custom-control-input"-->
<!--                        id="customRadio2"-->
<!--                        value="en"-->
<!--                        v-model="lang"-->
<!--                      />-->
<!--                      <label class="custom-control-label" for="customRadio2">-->
<!--                        <span class="img-flag">-->
<!--                          <img class="img-responsive" src="@/assets/images/english.png" alt="user" />-->
<!--                        </span>-->
<!--                        <span class="language">English</span>-->
<!--                      </label>-->
<!--                    </div>-->
                  </div>
                </div>
              </div>
              <div class="modal-footer mf-1st">
                <button
                  type="button"
                  class="btn   mode-d"
                  data-dismiss="modal"
                >{{ $t("cancel") }}</button>
                <button type="submit" class="btn btn-primary mode-s">{{ $t("save") }}</button>
                <div class="cross-close" data-dismiss="modal">
                  <img src="@/assets/images/cross.png" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="spinner-cover" style="display: block;">
        <div class="spinner"></div>
      </div>
   </header>
   <!-- end header -->
  </div>
</template>
<script>
import axios from 'axios'

import {
  required,
  email,
  minLength,
  numeric,
  sameAs
} from 'vuelidate/lib/validators'
import Header from "../appSetting/components/Header.vue";

export default {
  name: 'HelloWorld',
  components: {Header},
  data () {
    return {
      projectName: '',
      search_qry: '',
      submitted: false,
      nameShowInheader: '',
      submitted1: true,
      passwordChange: false,
      lang: this.$i18n.locale,
      currentpassword: '',
      password: '',
      repeatpassword: '',

      user: {
        pduserid: '',
        email: '',
        created: '',
        lastlogin: '',
        status: '',
        gender: '',
        title: '',
        firstname: '',
        lastname: '',
        company: '',
        street: '',
        zipcode: '',
        city: '',
        country: '',
        description: '',
        language: '',
        emailinfo: null,
        telefon: ''
      },
      modal3: [],
      emodal3: [],
      tabA: 1,
      tabC: 0,
      tabB: 0,
      search: '',
      projects_in_dropdown: []
    }
  },
  created () {
    if (this.projects.length < 1){
      this.$store.dispatch('getProjectsForDropDown');
    }
  },
  mounted () {
    this.changeLang();
    this.getrecord();
    this.getProject()
    this.getProjects()
    // this.getpreviewimages()
    $(".spinner-cover").hide();
  },
  validations () {
    if (this.passwordChange) {
      return {
        currentpassword: { required },
        password: { required, minLen: minLength(6) },
        repeatpassword: { required, sameAs: sameAs('password') },
        user: {
          firstname: { required },
          email: { required, email },
          lastname: { required },
          company: { required },
          gender: { required },
          telefon: { numeric }
        }
      }
    } else {
      return {
        user: {
          firstname: { required },
          email: { required, email },
          lastname: { required },
          company: { required },
          gender: { required },
          telefon: { numeric }
        }
      }
    }
  },
  beforeCreate () {
    // localStorage.apikey='5b9ccf76e45cba2867816580aa5b13b3';
    if (!localStorage.apikey) this.$router.push('/login')
  },
  computed: {
    projects(){
      return this.$store.state.projects.activeprojects.length ? this.$store.state.projects.activeprojects : this.$store.state.projects.projectsForDropDown
    },
    projectdropdown(){
      if (this.search_qry){
        return this.projects_in_dropdown.filter(item => item.name.toLowerCase().includes(this.search_qry.toLowerCase()))
      }
      return this.projects_in_dropdown
    }
  },
  methods: {
    activeSearchInput(){
      setTimeout(function (){
        const input = document.getElementById('projectSearchInput')
        input.focus();
      },400)
    },
    // redirectUrl () {
    //   window.location.reload()
    // },

    // getpreviewimages(project) {
    //   let _this = this
    //   this.projects.forEach(function(project, idx) {
    //     _this.getfileImage(project)
    //   })
    // },

    getImgUrl(tempProject) {
      return `${process.env.VUE_APP_GET_METHOD_URL}deco&projectid=${tempProject.projectid}&id=${tempProject.decoimage}&token=${localStorage.sessiontoken}&PHPSESSID=${localStorage.sessiontoken}`
    },

     getfileImage(tempProject , projects = null) {
      /*process.env.VUE_APP_BASE_AMF_URL + "getfile/decoimage/" + tempProject.decoimage_id + "/500*300/1.4:1",*/
      // console.log('TMP:', tempProject);
      let src
       fetch(process.env.VUE_APP_GET_METHOD_URL + "deco&projectid=" + tempProject.projectid + "&id=" + tempProject.decoimage + `&token=` + localStorage.sessiontoken,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
          }
        }).then(r => r.blob()).then(d => {
          if(d.size)
          {
            src = window.URL.createObjectURL(d)
            tempProject.src = window.URL.createObjectURL(d);
          }
          tempProject.src = src
        });
    },

     getProject () {
       const obj = this
       axios.post(process.env.VUE_APP_BASE_AMF_URL + `getProject&token=` + localStorage.sessiontoken,
         {
           "methodName": "getProject",
           "serviceName": "ProjectdocuService",
           "parameters": [this.$route.params.id]
         },{
           headers: {
             apitoken: localStorage.apikey,
             deviceid: localStorage.deviceid,
             accept: 'application/json'
           }
         })
         .then(response => {
           obj.projectName = response.data[0].name
           this.$store.commit('setMainProjectDetails',response.data[0])
           setTimeout(function () {
             $('.spinner-cover').hide()
           }, 1000)
         })
         .catch(e => {
           obj.errors.push(e);
         })
     },

    getProjects () {
      const _this = this
      axios.post(process.env.VUE_APP_BASE_AMF_URL + `getProjects&token=` + localStorage.sessiontoken,
        {
          parameters: [],
          serviceName: "ProjectdocuService",
          methodName: "getProjects"
        },{
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(response => {
          _this.projects_in_dropdown = response.data.reverse();
        }).catch(e => { _this.errors.push(e) })
    },

    changeLang () {
      this.$i18n.locale = this.lang
      localStorage.locale = this.lang
      $('#exampleModalCenter2').modal('hide')
    },


    async getrecord () {
     await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [],
        serviceName: "ProjectdocuService",
        methodName: "getCurrentUser"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
          this.$store.commit('setAuthUser',response.data[0]);
          this.user = response.data[0]
          localStorage.user = this.user
          this.nameShowInheader = `${this.user.firstname} ${this.user.lastname}`
        })
        .catch(e => {
          localStorage.clear()
          this.$router.push('/login')
        })
    },

   async logout () {
     await this.$store.dispatch('logout')
      localStorage.apikey = null
     await this.$router.push('/login')
    },

    updateProfile () {
      this.submitted = true
      let _this = this
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      if (this.passwordChange) {
        this.user.password = this.password
        this.user.password_rpt = this.repeatpassword
      }
      $('.spinner-cover').show()

      var params = [
        this.user.pduserid,
        this.user
      ]
      axios.post(process.env.VUE_APP_BASE_AMF_URL + `user/saveprofile`  + `&token=` + localStorage.sessiontoken,
        {
          parameters: params,
          serviceName: "ProjectdocuService",
          methodName: "updateUser"
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }
      ).then(response => {
        if (response.status === 200) {
          _this.$toast.success('Profil aktualisiert')
        }
        $('.spinner-cover').hide()
      })
        .catch(e => {
          $('.spinner-cover').hide()
          this.emodal3.push(e)
          console.log(e)

          // this.errors.push(e);
        })
    },

    updatePassword () {
      this.submitted1 = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      var params = new URLSearchParams()
      // params.append("api_token", localStorage.token);
    },

    emptyModal () {
      this.modal3 = []
      this.emodal3 = []
      this.passwordChange = false
    },
    openTab (dataName) {
      this.tabA = this.tabB = this.tabC = 0
      if (dataName == 'DataA') this.tabA = 1
      if (dataName == 'DataB') this.tabB = 1
      if (dataName == 'DataC') this.tabC = 1
      let i
      let x = document.getElementsByClassName('d1')
      for (i = 0; i < x.length; i++) {
        x[i].style.display = 'none'
      }
      document.getElementById(dataName).style.display = 'block'
    }
  },
  watch: {
    modal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    msg: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    emodal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    error: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    }
  }
}
</script>
<style scoped>
.projects-list-dropdown{
  min-width: 22rem;
}
  .active{
    background-color: #39F !important;
    color: #ffffff !important;
  }
  .navbar-nav a{
    /*font-size: 21px !important;*/
    padding: .5rem 1.6rem !important;
  }
.projects-dropdown .dropdown-menu.show {
    height: calc(100vh - 202px);
    overflow-y: scroll;
  }
.projects-dropdown a {
  color: #111111;
}
header.settings{
  height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/plan/Header.vue